import { Web3Provider } from "@ethersproject/providers";

export default function getLibrary(provider: any) {
  const library = new Web3Provider(
    provider,
    typeof provider.chainId === "number"
      ? provider.chainId
      : typeof provider.chainId === "string"
      ? parseInt(provider.chainId)
      : "any"
  );
  library.pollingInterval = 15_000;
  library.detectNetwork().then((network) => {
    const networkPollingInterval = 1000;
    if (networkPollingInterval) {
      library.pollingInterval = networkPollingInterval;
    }
  });
  return library;
}
